import { Component, OnInit, ViewEncapsulation } from '@angular/core'
import { Helpers } from '../../../helpers'

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-scroll-top',
  templateUrl: './scroll-top.component.html'
})
export class ScrollTopComponent implements OnInit {
  constructor () {}
  public ngOnInit () {}
}
